import { useEffect, useMemo, useState } from 'react'

import { Card } from 'antd'
import { faLinkSimple, faMerge, faSave, faStethoscope } from '@fortawesome/pro-solid-svg-icons'
import { isFunction } from 'lodash'

import { Properties } from '../../../utils/entities'
import SectorsList from '../../../Components/shared/Lists/SectorsList'
import IconButton from '../../../Components/antd/Buttons/IconButton'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import { useSelector } from 'react-redux'
import { selectUser } from '../../../reducers/UserReducer'
import { isObject, validateString } from '../../../utils'
import { getInstitutionSectors } from '../../../utils/api/institution'
import IconLabel from '../../../Components/icons/IconLabel'

const { NAME } = Properties

const SectorValidator = ({ sector, sectors = [], institution = {}, onValidate, onMerge, onSkip }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [selectedSector, setSelectedSector] = useState(null)
  const [institutionSectors, setInstitutionSectors] = useState([])

  useEffect(() => {
    if (isObject(institution) && sectors.length === 0) {
      getInstitutionSectors(user, institution).then(json => {
        if (json?.data) {
          setInstitutionSectors(json.data)
        }
      })
    }
  }, [sectors.length, institution.id, user.id])

  const sectorsList = useMemo(() => sectors.length === 0 ? institutionSectors : sectors, [sectors, institutionSectors])
  /** A student names no service when he types a place in by hand : there is then nothing to create, only one to pick. */
  const hasSectorName = validateString(sector[NAME], { notEmpty: true }).valid

  return (
    <div className='h-100 w-100 flex-row'>
      <div className='flex-column h-100 w-50 mr-8 jc-between'>
        <h3>{t('sector_validator.title.sector_to_validate')}</h3>
        <Card size='small' title={t('common.sector')}>
          <IconLabel icon={faStethoscope} text={hasSectorName ? sector[NAME] : t('sector_validator.no_sector_proposed')} fontSize='small' />
        </Card>
      </div>
      <div className='flex-column h-100 w-50'>
        <h3>{t('sector_validator.title.sectors_list')}</h3>
        <SectorsList selected={selectedSector} sectors={sectorsList} onSelectedChange={setSelectedSector} />
        <IconButton
          className='mt-12'
          disabled={!selectedSector && !hasSectorName}
          icon={selectedSector ? faMerge : faSave}
          text={t(`sector_validator.${selectedSector ? 'merge_button' : 'validate_button'}`)}
          type='primary'
          onClick={() => selectedSector ? onMerge({ id: selectedSector }) : onValidate(sector)}
        />
        {!hasSectorName && isFunction(onSkip) && (
          /** Nothing to create and nothing worth picking : the place alone still has to reach the request. */
          <IconButton
            className='mt-8'
            icon={faLinkSimple}
            text={t('sector_validator.skip_button')}
            onClick={onSkip}
          />
        )}
      </div>
    </div>
  )
}

export default SectorValidator
